import { render, staticRenderFns } from "./SnowBoxList.vue?vue&type=template&id=57a90fe0&scoped=true&"
import script from "./SnowBoxList.vue?vue&type=script&lang=ts&"
export * from "./SnowBoxList.vue?vue&type=script&lang=ts&"
import style0 from "./SnowBoxList.vue?vue&type=style&index=0&id=57a90fe0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a90fe0",
  null
  
)

export default component.exports